import "@master/normal.css";
import { StrictMode } from "react";
import { ConfigProvider, theme } from "antd";
import zhTW from "antd/locale/zh_TW";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { initRuntime } from "@master/css";

import "@/styles/base.css";
import "@/plugins/dayjs";
import { masterConfig } from "@/master.css";
import { AppConfigProvider } from "@/providers";
import { store } from "@/stores";
import App from "@/App";

initRuntime(masterConfig);

const render = () => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Provider store={store}>
        <ConfigProvider
          locale={zhTW}
          theme={{
            algorithm: theme.compactAlgorithm,
            token: {
              fontSize: 16,
              fontWeightStrong: 500,
              fontFamily: `'Ubuntu Mono', 'Noto Sans TC', monospace, sans-serif`,
            },
          }}
        >
          <AppConfigProvider>
            <App />
          </AppConfigProvider>
        </ConfigProvider>
      </Provider>
    </StrictMode>
  );
};

render();
